import { RouteMeta, RouteRecordRaw } from 'vue-router';
import { Groups } from 'src/services/security';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        name: 'dashboard',
        meta: {
          title: 'Dashboard',
        },
        component: () => import('pages/Index.vue'),
      },
      {
        path: '/boards',
        name: 'board-actions',
        meta: {
          title: 'Board Actions',
        },
        component: () => import('pages/board/List.vue'),
      },
      {
        path: '/boards/:boardId',
        name: 'board',
        meta: {
          title: 'Board Details',
        },
        component: () => import('pages/board/View.vue'),
      },
      {
        path: '/tasks/',
        name: 'tasks',
        meta: {
          title: 'Tasks',
          conditionalRoute: true,
        },
        component: () => import('pages/tasks/List.vue'),
      },
      {
        path: '/postings/',
        name: 'postings',
        meta: {
          title: 'Postings',
          conditionalRoute: true,
          auth: {
            groups: [Groups.Developers],
          },
        },
        component: () => import('pages/posting/List.vue'),
      },
      {
        path: '/postings/:postingId',
        name: 'posting',
        meta: {
          title: 'Posting Details',
        },
        component: () => import('pages/posting/View.vue'),
        children: [
          {
            path: '/postings/:postingId/job',
            name: 'posting-job-info',
            meta: {
              title: 'Posting / Job Info',
              conditionalRoute: true,
            },
            component: () => import('pages/posting/View-JobInfo.vue'),
          },
          {
            path: '/postings/:postingId/history',
            name: 'posting-history',
            meta: {
              title: 'Posting / History',
              conditionalRoute: true,
            },
            component: () => import('pages/posting/View-History.vue'),
          },
        ],
      },
      {
        path: '/auth/login',
        name: 'login',
        meta: {
          title: 'Login',
        },
        component: () => import('pages/auth/Login.vue'),
      },
      {
        path: '/auth/logout',
        name: 'logout',
        meta: {
          title: 'Logout',
        },
        component: () => import('pages/auth/Logout.vue'),
      },
      {
        path: '/auth',
        name: 'auth',
        meta: {
          title: 'Authenticate',
        },
        component: () => import('pages/auth/Auth.vue'),
      },
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/Error404.vue'),
  },
];

export default routes;

export interface RouteCustomMeta extends RouteMeta {
  title: string;
  conditionalRoute: boolean;
  auth: {
    groups: string[];
  };
}
